import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalService } from 'ClientApp/app/shared/modules/bs-modal/services/modal.service';
import { Subscription } from 'rxjs';
import { IDirectDebitPopupLegContent } from '../../interfaces/IContentResponse.interface';
import { DirectDebitService } from '../../services/direct-debit.service';

@Component({
    selector: 'app-popup-legal',
    templateUrl: './popup-legal.component.html',
    styleUrls: ['./popup-legal.component.scss']
})
export class PopupLegalComponent implements OnInit, OnDestroy {
    subs: Subscription[] = [];
    content: IDirectDebitPopupLegContent;
    constructor(private directDebSrv: DirectDebitService, private modalSrv: ModalService) {
        this.subs.push(
            this.directDebSrv.contents$.subscribe((x) => {
                this.content = x.popupLegal;
            })
        );
    }
    ngOnDestroy(): void {
        this.subs.forEach((x) => x.unsubscribe());
    }

    ngOnInit(): void {}

    close(): void {
        this.modalSrv.closeModalAndAlertSubscribers(true);
    }
}
